<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.research') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5" v-if="$i18n.locale === 'en'">
                            We focus our research on Green Technology
                          </h2>
                          <h2 class="white--text text-md-h4 mb-5" v-if="$i18n.locale === 'id'">
                            Kami memfokuskan penelitian kami pada Green Technology
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2
                v-if="$i18n.locale === 'en'"
                class="text-md-h4 font-weight-bold sub-title-page">
                Jurusan Teknik Mesin Research
              </h2>
              <h2
                v-if="$i18n.locale === 'id'"
                class="text-md-h4 font-weight-bold sub-title-page">
                Riset Jurusan Teknik Mesin
              </h2>
            </v-col>
            <v-col cols="12" md="6" v-if="$i18n.locale === 'en'">
              <div class="font-weight-bold">
                Our Research Topics:
              </div>
              <v-divider class="my-2"></v-divider>
              <ul class="text-justify">
                <li>Appropriate technology in agriculture, livestock, and fisheries;</li>
                <li>Appropriate technology to increase the productivity of SMEs to support tourism;</li>
                <li>Appropriate technology with new and renewable energy sources;</li>
                <li>Product innovation-based technology, economical, environmentally friendly, energy-efficiency, and ergonomics;</li>
                <li>K3 and environmental studies from the Mechanical Engineering aspect;</li>
                <li>Fundamental study of sustainable technology and energy conservation;</li>
                <li>Energy-saving and environmentally friendly Refrigeration Heating Ventilating and Air Conditioning (RHVAC) technology;</li>
                <li>Energy conservation technology in hotel utility systems, other commercial buildings, and industries;</li>
                <li>Building automation technology, optimization of utility systems and thermal energy storage;</li>
                <li>Agricultural refrigeration technology, fisheries, food transport and supply;</li>
                <li>Automotive energy conservation technology;</li>
                <li>Sustainable technology with new and renewable energy sources</li>
              </ul>
            </v-col>
            <v-col cols="12" md="6" v-if="$i18n.locale === 'id'">
              <div class="font-weight-bold">
                Topik Penelitian Kami:
              </div>
              <v-divider class="my-2"></v-divider>
              <ul class="text-justify">
                <li>Teknologi tepat guna di bidang pertanian, peternakan, dan perikanan;</li>
                <li>Teknologi tepat guna untuk meningkatkan produktivitas UKM;</li>
                <li>Teknologi tepat guna dengan sumber energi baru dan terbarukan;</li>
                <li>Produk berbasis inovasi teknologi, ekonomis, ramah lingkungan, hemat energi, dan ergonomis;</li>
                <li>Kajian K3 dan lingkungan dari aspek Teknik Mesin;</li>
                <li>Studi mendasar tentang teknologi berkelanjutan dan konservasi energi;</li>
                <li>Teknologi Refrigeration Heating Ventilating and Air Conditioning (RHVAC) yang hemat energi dan ramah lingkungan;</li>
                <li>Teknologi konservasi energi dalam sistem utilitas hotel, bangunan komersial lainnya, dan industri;</li>
                <li>Membangun teknologi otomasi bangunan, optimalisasi sistem utilitas dan penyimpanan energi panas;</li>
                <li>Teknologi pendingin pertanian, perikanan, transportasi dan pasokan makanan;</li>
                <li>Teknologi konservasi energi otomotif;</li>
                <li>Teknologi berkelanjutan dengan sumber energi baru dan terbarukan</li>
              </ul>
            </v-col>
            <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
              <!-- <v-divider vertical></v-divider> -->
            </v-col>
            <v-col cols="12" md="5" class="align-self-center">
              <v-img
                :src="require('./../assets/research-01.jpg')">
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <!-- lab -->
    <v-container fluid fill-height class="py-10 min-height-pages bacground-maincolor">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="12">
            <v-row justify="center" class="white--text">
              <v-col cols="12" md="12">
                <h2
                  v-if="$i18n.locale === 'en'"
                  class="text-md-h4 font-weight-bold sub-title-page">
                  Laboratories & Workshop
                </h2>
                <h2
                  v-if="$i18n.locale === 'id'"
                  class="text-md-h4 font-weight-bold sub-title-page">
                  Laboratorium & Workshop
                </h2>
              </v-col>
              <v-col cols="12" md="6">
                <ul v-if="$i18n.locale === 'en'">
                  <li>Automotive Lab </li>
                  <li>Instrumentation and Control Lab</li>
                  <li>MEP and Sustainable Energy Lab</li>
                  <li>Mechanical Lab </li>
                  <li>Basic and Applied Refrigeration Lab</li>
                  <li>Basic and Applied Air Conditioning Lab</li>
                  <li>Material, Pneumatic & Hydraulic Testing Lab</li>
                  <li>Building Automatic system and Digital Instruments lab</li>
                  <li>Design and Computer Lab</li>
                </ul>
                <ul v-if="$i18n.locale === 'id'">
                  <li>Lab Otomotif </li>
                  <li>Lab Instrumentasi dan Kontrol</li>
                  <li>MEP dan Lab Energi Berkelanjutan</li>
                  <li>Laboratorium Mekanik </li>
                  <li>Laboratorium Pendinginan Dasar dan Terapan</li>
                  <li>Laboratorium Pendingin Udara Dasar dan Terapan</li>
                  <li>Laboratorium Pengujian Material, Pneumatik & Hidraulik</li>
                  <li>Membangun lab sistem Otomatis dan Instrumen Digital</li>
                  <li>Lab Desain dan Komputer</li>
                </ul>
              </v-col>
              <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                <!-- <v-divider vertical></v-divider> -->
              </v-col>
              <v-col cols="12" md="5" class="align-self-center">
                <v-img
                  height="200px"
                  :src="require('./../assets/bg-mesin.jpg')">
                </v-img>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-divider></v-divider>
    <!-- publikasi -->
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12" class="text-justify">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                {{ $t('title.publication') }}
              </h2>
              <p v-if="$i18n.locale === 'en'">
                We have journal publications on the open Journal System to showcase the results of various fields of research. For details of our publications, follow this link:
                <a href="https://ojs2.pnb.ac.id/index.php" target="_blank">https://ojs2.pnb.ac.id/index.php</a>
              </p>
              <p v-if="$i18n.locale === 'id'">
                Kami memiliki beberapa publikasi jurnal pada Sistem Jurnal terbuka untuk mempublikasikan beberapa hasil dari berbagai bidang penelitian. Untuk detail publikasi kami, silakan ikuti tautan ini:
                <a href="https://ojs2.pnb.ac.id/index.php" target="_blank">https://ojs2.pnb.ac.id/index.php</a>
              </p>
            </v-col>
            <v-col cols="12" md="12">
              <v-sheet
                :rounded="'lg'"
                color="transparent"
                v-if="jurnallist.length">
                <v-slide-group
                  v-model="slidejournal"
                  class="transparent slide-style-pnb">
                  <v-slide-item
                    v-for="(jur, i) in jurnallist"
                    :key="i"
                    v-slot="{ active }"
                    class="mr-3">
                    <v-card
                      tile
                      :color="active ? maincolor : 'white'"
                      class="my-2"
                      width="200">
                      <v-img
                        :lazy-src="require('../assets/default.jpg')"
                        class="white--text"
                        max-height="300"
                        position="center"
                        :src="jur.urlpic">
                      </v-img>
                      <v-card-text class="text--primary">
                        <div class="font-weight-black">
                          <a
                            class="text-decoration-none"
                            :href="jur.jo_web"
                            :title="jur.jo_title"
                            target="_blank">
                            {{ jur.jo_title }}
                          </a>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
              <v-row v-if="!jurnallist.length">
                <v-col cols="12" md="12">
                  <div class="grey--text my-2">
                    Jurnal pada kategori ini tidak ditemukan.
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <v-btn
                    block
                    large
                    :color="maincolor"
                    dark
                    :to="{ name: 'Research' }">
                    {{ $t('button.exploremore') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <!-- produk unggulan -->
    <v-container fluid fill-height class="py-10 min-height-pages bacground-gray">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="text-md-h4 font-weight-bold sub-title-page">
              {{ $t('title.product') }}
            </h2>
          </v-col>
        </v-row>
        <v-row v-if="produklist.length">
          <v-col
            class="d-flex"
            cols="12"
            md="4"
            v-for="(pro, i) in produklist"
            :key="i">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="pro.urlpic">
              </v-img>
              <v-card-subtitle>
                <h1 class="title font-weight-bold mb-3">
                  <router-link class="text-decoration-none text-ellipsis--2"
                    :title="pro.pro_title"
                    :to="{ name: 'NewsDetail', query: { berita: pro.pro_id } }">
                    {{ pro.pro_title }}
                  </router-link>
                </h1>
                <div class="d-flex">
                  <v-chip
                    class="mr-1"
                    color="primary"
                    small
                    dark>
                    <v-icon left small>
                      mdi-alpha-c-circle
                    </v-icon>
                    {{ pro.pro_cat }}
                  </v-chip>
                </div>
              </v-card-subtitle>
              <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
                <div v-html="pro.pro_prev"></div>
              </v-card-text>
              <v-card-actions v-if="false">
                <v-btn
                  class="mx-2"
                  fab
                  depressed
                  dark
                  x-small
                  :to="{ name: 'NewsDetail', query: { berita: pro.pro_id } }">
                  <v-icon dark>
                    mdi-arrow-right
                  </v-icon>
                </v-btn>
                <span>{{ $t('button.readmore') }}</span>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              large
              :color="maincolor"
              dark>
              {{ $t('button.exploremore') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!produklist.length">
          <v-col cols="12" md="12">
            <div class="grey--text my-2">
              Produk pada kategori ini tidak ditemukan.
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              large
              :color="maincolor"
              dark>
              {{ $t('button.exploremore') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-divider></v-divider>
    <!-- berita -->
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.researchnews') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'penelitian' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'penelitian' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Research',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    jurnallist: [],
    produklist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    paramjurnal: {
      limit: '',
      lang: '',
    },
    paramproduk: {
      limit: '',
      lang: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    slidejournal: null,
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/bg-research.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
    this.getJurnal();
    this.getProduk();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
      this.getJurnal();
      this.getProduk();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'penelitian';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getJurnal() {
      this.jurnallist = [];
      this.paramjurnal.lang = this.$i18n.locale;
      // this.paramjurnal.limit = '';
      this.axios
        .get(
          this.api + '/public/journal',
          {
            params: this.paramjurnal,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.jo_pic) {
                  element.urlpic = this.api + '/upload/journal/' + element.jo_pic;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.jurnallist.push(element);
              });
              // console.log(this.jurnallist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getProduk() {
      this.produklist = [];
      this.paramproduk.lang = this.$i18n.locale;
      this.paramproduk.limit = 6;
      this.axios
        .get(
          this.api + '/public/product',
          {
            params: this.paramproduk,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pro_pic) {
                  element.urlpic = this.api + '/upload/product/' + element.pro_pic;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.produklist.push(element);
              });
              // console.log(this.produklist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
